import { type LucideProps } from 'lucide-react';
import { createElement } from 'react';
import { resolveNavIcon } from '@/lib/icons';

/** Renders a lucide icon by its kebab-case manifest name (falls back to a neutral icon). */
export function NavIcon({ name, ...props }: LucideProps & { name: string | null | undefined }) {
  return createElement(resolveNavIcon(name), props);
}
